import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, GitCompare, Check } from "lucide-react";
import { formatIDR, buildWaLink } from "../lib/whatsapp";
import { useCompare } from "../lib/compareStore";

export default function MotorCard({ motor, index = 0 }) {
  const { toggle, has, slugs, max } = useCompare();
  const inCompare = has(motor.slug);
  const disabled = !inCompare && slugs.length >= max;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-30px" }}
      transition={{ duration: 0.4, delay: (index % 8) * 0.04, ease: [0.2, 0.7, 0.2, 1] }}
      whileHover={{ y: -3 }}
      className="group relative bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col hover:shadow-lg hover:border-slate-300 transition-all"
      data-testid={`motor-card-${motor.slug}`}
    >
      {/* Compare toggle */}
      <button
        onClick={() => !disabled && toggle(motor.slug)}
        disabled={disabled}
        data-testid={`motor-compare-${motor.slug}`}
        title={inCompare ? "Hapus dari perbandingan" : "Bandingkan"}
        className={`absolute top-2 right-2 z-10 inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-semibold transition-all ${
          inCompare
            ? "bg-[#002d62] text-white"
            : disabled
              ? "bg-slate-100 text-slate-400 cursor-not-allowed"
              : "bg-white/90 backdrop-blur border border-slate-200 text-slate-600 hover:border-[#002d62] hover:text-[#002d62]"
        }`}
      >
        {inCompare ? <Check className="w-3 h-3" /> : <GitCompare className="w-3 h-3" />}
        <span className="hidden sm:inline">{inCompare ? "Dibandingkan" : "Compare"}</span>
      </button>

      <Link
        to={`/motor/${motor.slug}`}
        className="relative block aspect-[4/3] bg-white overflow-hidden"
      >
        <img
          src={motor.image}
          alt={motor.name}
          loading="lazy"
          className="w-full h-full object-contain p-3 sm:p-5 transition-transform duration-500 group-hover:scale-105"
        />
      </Link>

      <div className="px-3 sm:px-4 pb-3 sm:pb-4 pt-1 flex flex-col gap-1">
        <h3 className="font-display font-bold text-sm sm:text-base text-slate-900 leading-tight line-clamp-1">
          {motor.name}
        </h3>
        <p className="text-[10px] sm:text-[11px] text-slate-500 leading-tight line-clamp-1">
          {motor.priceLabel}
        </p>
        <p
          className="font-display font-extrabold text-sm sm:text-base text-[#002d62] leading-tight"
          data-testid={`motor-price-${motor.slug}`}
        >
          {formatIDR(motor.price_idr)}
        </p>

        <div className="mt-2 sm:mt-3 grid grid-cols-2 gap-1.5">
          <Link
            to={`/motor/${motor.slug}`}
            data-testid={`motor-detail-${motor.slug}`}
            className="inline-flex items-center justify-center px-2 py-2 rounded-lg bg-[#002d62] hover:bg-[#001a3f] text-white text-[11px] sm:text-xs font-semibold transition-colors"
          >
            Details
          </Link>
          <a
            href={buildWaLink(motor.name)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`motor-wa-${motor.slug}`}
            className="inline-flex items-center justify-center gap-1 px-2 py-2 rounded-lg bg-[#25D366] hover:bg-[#1ebe57] text-white text-[11px] sm:text-xs font-semibold transition-colors"
          >
            <MessageCircle className="w-3 h-3" /> WhatsApp
          </a>
        </div>
      </div>
    </motion.div>
  );
}
